var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"host-map",attrs:{"id":_vm.sectionId}},[_c('div',{ref:"map",staticClass:"map-box"})])}
var staticRenderFns = []

export { render, staticRenderFns }